const Vue = require('vue')
const Purify = require('dompurify')

Vue.component('html-sandbox', {
    props: {
        html: {
            required: true
        },
        maxHeight: {
            type: Number,
            default: 300
        },
        onSandboxUrlReady: {
            type: Function,
            default: () => {}
        }
    },
    data () {
        return {
            blobUrl: null
        }
    },
    ready () {
        this.update(this.html)
    },
    methods: {
        update (html) {
            setTimeout(() => {
                const head = `
                    <meta http-equiv="Content-Type" content="text/html;charset=UTF-8"/>
                    <style>html{font-family: sans-serif}</style>
                `
                let realHtml = null;
                if (html.includes("</head>")) {
                    realHtml = html.replace(/<\/head>/g, `${head}</head>`)
                } else {
                    realHtml = `<html><head>${head}</head><body>${html}</body></html>`
                }
                //

                const blob = new Blob(
                    [
                        realHtml
                    ],
                    { type: 'text/html;charset=UTF-8' }
                )

                this.blobUrl = URL.createObjectURL(blob)

                if (this.onSandboxUrlReady) {
                    this.onSandboxUrlReady(this.blobUrl)
                }
            }, 0)
        }
    },
    watch: {
        html () {
            this.update(this.html)
        }
    },
    template: `
        <div class="html-sandbox" :style="{maxHeight: maxHeight + 'px', overflow: 'auto'}">
            <iframe v-el:iframe :style="{height: height + 'px'}" style="width: 100%; overflow: auto" :src="blobUrl"></iframe>
        </div>
    `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/html-sandbox.js